module.exports = __webpack_public_path__ + "img/clothing.ab5c27ae.png";